import React from "react";
import { ThemeProvider } from "styled-components";
import ReactDOM from "react-dom/client";
import "./internationalization/i18n";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { GlobalFonts } from "./styles/globalFonts";
import { GlobalStyle } from "./styles/globalStyle";
import { mindler2022theme } from "./styles/mindler2022theme";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <ThemeProvider theme={mindler2022theme}>
      <GlobalFonts />
      <GlobalStyle />
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>,
);
